import React from 'react';
import LayoutOverview from '../components/LayoutOverview';

export function HomePageLayout() {
  return <LayoutOverview />;
}
